import { motion } from "framer-motion";

const SRC = {
  hero: "/mole.webp",
  hi: "/mole-hi.webp",
  burrow: "/mole-burrow.webp",
  gift: "/mole-gift.webp",
};

export const Mole = ({ className = "", variant = "hero", ...props }) => (
  <motion.img
    src={SRC[variant] || SRC.hero}
    alt="Кротик NORA в наушниках"
    draggable="false"
    className={`select-none ${className}`}
    style={{ transformOrigin: "50% 88%" }}
    whileHover={
      variant === "burrow"
        ? undefined
        : {
            rotate: [0, -5, 5, -3, 0],
            transition: { duration: 0.55, ease: "easeInOut" },
          }
    }
    {...props}
  />
);
